import { useEffect } from "react";
import { Link } from "react-router-dom";

const Home = (props) => {
  const pageName = "모바일 페이지 목록";
  const headerUi = {
    onback: false,
    closeAll: false,
  };
  useEffect(() => {
    props.onPageName(pageName);
  }, []);
  useEffect(() => {
    props.onHeaderUi(headerUi);
  }, []);

  return (
    <div>
      <div className="container" style={{ textAlign: "center" }}>
        <ul className="home">
          <li>
            <Link to="/terms" className="font-header">
              약관
            </Link>
          </li>
          <li>
            <Link to="/drawal" className="font-header">
              탈퇴하기
            </Link>
          </li>
          <li>
            <Link to="/faq" className="font-header">
              FAQ/문의하기
            </Link>
          </li>
          <li>
            <Link to="/kakao" className="font-header">
              카카오 주소 API
            </Link>
          </li>
          <li>
            <Link to="/notice" className="font-header">
              공지사항
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};
export default Home;
